<template>
	<page>
		<module title="提现申请详情">
			<c-detail >
				<c-detail-item label="商家" full >
					{{detailData.stationed_name}}
				</c-detail-item>
				<c-detail-item label="提现单号" >
					{{detailData.apply_number}}
				</c-detail-item>
				<c-detail-item label="状态" >
					{{stateName}}
				</c-detail-item>
				<c-detail-item label="提现金额" >
					￥{{detailData.extract_money}}
				</c-detail-item>
				<c-detail-item label="提现手续费" >
					￥{{detailData.withdraw_fee}}
				</c-detail-item>
				<c-detail-item label="提现至" full>
					<c-image v-if="detailData.withdraw_img_url" :src="detailData.withdraw_img_url" size="120" preview></c-image>
					{{withdrawChannelName}}
				</c-detail-item>
				<c-detail-item label="备注" full>
					{{detailData.remark}}
				</c-detail-item>
				<c-detail-item label="申请人" >
					{{detailData.apply_user_realname}}
				</c-detail-item>
				<c-detail-item label="申请时间">
					{{detailData.apply_date}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 2 || detailData.state == 3 || detailData.state == 4 || detailData.state == 5 || detailData.state == 10" label="审批时间">
					{{detailData.audit_date}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 2 || detailData.state == 3 || detailData.state == 4 || detailData.state == 5 || detailData.state == 10" label="审批人姓名">
					{{detailData.audit_user_realname}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 10" label="驳回原因" full>
					{{detailData.reject_reason}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 4" label="打款时间">
					{{detailData.playmoney_date}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 4" label="打款人姓名">
					{{detailData.playmoney_user_realname}}
				</c-detail-item>
				<c-detail-item v-if="detailData.state == 4" label="打款凭证">
					<c-image :src="detailData.playmoney_voucher_url" size="120" preview v-if="this.detailData.withdraw_channel != 4"></c-image>
					<span v-else>到账情况请查看代理收支</span>
				</c-detail-item>
				
			</c-detail>
			
			<template slot="button">
				<c-button size="m" v-if="detailData.state == 1" power="b_stationed_account_extract_approval" @click="approval(detailData,2)">审批</c-button>
				<c-button size="m" v-if="detailData.state == 1" power="b_stationed_account_extract_approval" hollow @click="approval(detailData,10)">驳回</c-button>
				<c-button size="m" v-if="detailData.state == 2" power="b_stationed_account_extract_pay" @click="openPay(detailData)">打款</c-button>
			</template>
		</module>
		
		<c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="orderApprovalHandle">
			<div class="approval-eason">
				<textarea v-model="approvalReason" placeholder="请输入驳回原因..."></textarea>
			</div>
		</c-dialog>
		
		<c-dialog ref="playmoneyVoucher" title="打款凭证" width="400" @resolve="orderPayHandle">
			<c-form ref="uForm">
				<c-form-item type="image" label="打款凭证" name="playmoney_voucher_url" file-word="" required ></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>
		
	</page>
</template>

<script>
	export default {
		name: 'stationed_account_extract_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {},
				approvalReason: ''
			}
		},
        watch: {
            id(){
                this.detail();
            }
        },
		mounted() {
			this.detail();
		},
		computed: {
			stateName() {
				return {
					1: '待审批',
					2: '待打款',
					3: '待到账',
					4: '打款到帐',
					5: '打款失败',
					10: '审批驳回'
				}[this.detailData.state];
			},
			withdrawChannelName() {
				return {
					1: this.detailData.account_name + '（银行卡：' + this.detailData.bank_name + ',' +  this.detailData.account_name + ',' + this.detailData.bank_card+'）',
					2: this.detailData.withdraw_account_number+'（支付宝）' ,
					3: this.detailData.withdraw_account_number+'（微信）' ,
					4: '（平台账户）' 
				}[this.detailData.withdraw_channel]
			}
		},
		methods: {
			detail() {
				this.request({
					url: '/stationed/extract/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			},
			orderApprovalHandle(stop){
				
				if (!this.approvalReason.trim()) {
					this.$message({
						text: '请填写驳回原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/stationed/extract/approval',
					data: {id:this.id,state:10,reject_reason:this.approvalReason.trim()},
					loading: true,
					success: data => {
						this.$message({
							text: '驳回成功',
							icon: 'success'
						});
						this.$bus.$emit('stationed_account_extract.update', {})
						this.detail();
					}
				});
			},
			approval(val,state) {
				if(state == 10){
						this.$refs.approvalReason.open();
				}else if(state == 2){
					this.$confirm({
						text: '确定要审批通过【'+val.apply_number+'】吗？',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stationed/extract/approval',
								data: {id:val.id,state:state},
								loading: true,
								success: data => {
									this.$message({
										text: '审批通过成功',
										icon: 'success'
									});
									this.$bus.$emit('stationed_account_extract.update', {});
									this.detail();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}
			},
			orderPayHandle(stop){
				stop();
				this.$refs.uForm.submit({
					url: '/stationed/extract/pay',
					rule: {
						playmoney_voucher_url: [{
							type: 'empty',
							word: '请上传打款凭证图片'
						}]
					},
					dataFormatter: data => {
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '打款成功',
							icon: 'success'
						});
						this.$bus.$emit('stationed_account_extract.update', {});
						this.$refs.playmoneyVoucher.close();
						this.detail();
					},
				});
			},
			openPay(val) {
				//提现至平台账户
				if(val.withdraw_channel == 4){
					this.$confirm({
						text: '提现单【'+val.apply_number+'】的到账类型为平台账户，确定要执行打款操作吗？',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stationed/extract/pay',
								data: {id:val.id,playmoney_voucher_url:" "},
								loading: true,
								success: data => {
									this.$message({
										text: '打款成功',
										icon: 'success'
									});
									this.$bus.$emit('stationed_account_extract.update', {});
									this.detail();
									
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}else{
					//需要上传凭证
					this.$refs.uForm.set(val);
					this.$refs.playmoneyVoucher.open();
				}
			}
		}
	}
</script>
	
<style lang="stylus" scoped>
	.approval-eason {
		padding: 20px;
		
		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 10px 14px;
			line-height: 20px;
			background: #FAFAFA;
			resize: none;
		}
	}
</style>